/**
 * TeamDetails Component - Refactored Export
 * This component is now modularized into:
 * - TeamDetailsContainer (main orchestrator)
 * - TeamHeader (header & navigation)
 * - TeamOverviewTab (overview tab)
 * - TeamMembersTab (members tab)
 * - TeamRequestsTab (pending requests)
 * - TeamStatsTab (statistics)
 * - TeamModals (confirmation dialogs)
 * - Custom hooks (useTeamData, useTeamModals, useTeamActions)
 *
 * See TeamDetailsContainer.js for the full implementation
 */

import TeamDetailsContainer from "./TeamDetailsContainer";

export default TeamDetailsContainer;

